import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import menuData from "../Data/MenuData";
import { usePermission } from "../Auth/PermissionProvider";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const { permissions, loading } = usePermission();
  const [activeMenu, setActiveMenu] = useState(null);
  const [filteredMenu, setFilteredMenu] = useState([]);
  useEffect(() => {
    const active = menuData.find((item) =>
      item.subMenu?.some((sub) => sub.path === location.pathname)
    );

    if (active?.id) {
      setActiveMenu(active.id);
    } else {
      setActiveMenu(null);
    }
  }, [location.pathname]);

  const toggleCollapse = (id) => {
    setActiveMenu((prev) => (prev === id ? null : id));
    toggleSidebar();
  };

  const isActive = (path) => location.pathname === path;

  // Filter menu by permissions
  useEffect(() => {
    if (loading) return;

    const hasPermission = (pageKey) => {
      return permissions.pages.includes(pageKey?.toLowerCase());
    };

    const newMenu = menuData.reduce((acc, item) => {

      // Menu with submenu
      if (item.subMenu) {

        const filteredSub = item.subMenu.filter((sub) =>
          hasPermission(sub.id)
        );

        if (filteredSub.length > 0) {
          acc.push({ ...item, subMenu: filteredSub });
        }

      } 
      
      // Single menu
      else if (hasPermission(item.id)) {
        acc.push(item);
      }

      return acc;

    }, []);

    setFilteredMenu(newMenu);

  }, [permissions, loading]);

  if (loading) return null;

  return (
    <nav
      className={`sidebar sidebar-offcanvas ${isOpen ? "active" : ""}`}
      id="sidebar"
    >
      <ul className="nav">

        {filteredMenu.map((item) => {

          const isSubMenu = Boolean(item.subMenu);
          const isOpenMenu = item.id === activeMenu;

          return (
            <li
              key={item.id}
              className={`nav-item ${
                isActive(item.path) ||
                (isSubMenu &&
                  item.subMenu.some((sub) => isActive(sub.path)))
                  ? "active"
                  : ""
              }`}
            >

              {isSubMenu ? (
                <>
                  <Link
                    className="nav-link"
                    to="#"
                    onClick={() => toggleCollapse(item.id)}
                  >
                    <span className="custom-menu-title">{item.label}</span>
                    <i className={`${item.icon} menu-icon`} />
                  </Link>

                  <div className={`collapse ${isOpenMenu ? "show" : ""}`}>
                    <ul className="nav flex-column sub-menu">

                      {item.subMenu.map((sub) => (
                        <li
                          key={sub.id}
                          className={`nav-item ${
                            isActive(sub.path) ? "active" : ""
                          }`}
                        >
                          <Link
                            className="nav-link"
                            to={sub.path}
                            onClick={toggleSidebar}
                          >
                            <i className="fa-solid fa-arrow-right" />
                            <span className="custom-menu mx-4">
                              {sub.label}
                            </span>
                          </Link>
                        </li>
                      ))}

                    </ul>
                  </div>
                </>
              ) : (
                <Link
                  className="nav-link"
                  to={item.path}
                  onClick={toggleSidebar}
                >
                  <span className="custom-menu-title">{item.label}</span>
                  <i className={`${item.icon} menu-icon`} />
                </Link>
              )}

            </li>
          );
        })}

      </ul>
    </nav>
  );
};

export default Sidebar;